module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"only_good_below":"100 % coverage below this line"},"cs":{"only_good_below":"Pouze 100 % pokrytí pod touto čárou"}}')
  delete Component.options._Ctor
}
